import React from 'react'

const Error = ({ width = 18.032, height = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
  >
    <path
      fill="#b18935"
      d="M12.107,1.5,16.5,5.893v6.213L12.107,16.5H5.893L1.5,12.107V5.893L5.893,1.5ZM12.728,0H5.272L0,5.272v7.456L5.272,18h7.456L18,12.728V5.272ZM8.25,4.5h1.5v6H8.25ZM9,13.688a.938.938,0,1,1,.938-.937A.938.938,0,0,1,9,13.688Z"
    />
  </svg>
)

export default Error
